import * as classNames from "classnames"
require('./ctech_calcalist_site_hamburgerButton.less')

interface HamburgerProps {
    onToggleMenu: () => void
    isOpened: boolean
    headerNewDesign?: boolean
}

export class HamburgerButtonComponenta extends React.Component<HamburgerProps, {}> {
    constructor(props) {
        super(props)
    }
    render() {
        const { onToggleMenu, isOpened, headerNewDesign } = this.props
        let hamburgerCalssName = classNames("hamburger", { "active": isOpened })
        return (
            <div id="menu-button" className={hamburgerCalssName} onClick={onToggleMenu}>
                {headerNewDesign ? (
                    <>
                        <i className="hamburgerOpen" aria-hidden="true" />

                        <i className="hamburgerClose" aria-hidden="true" />
                    </>
                ) : (
                    <span></span>
                )}
            </div>
        )
    }
}